import { render, staticRenderFns } from "./HalfSib.vue?vue&type=template&id=43df86de&"
import script from "./HalfSib.vue?vue&type=script&lang=js&"
export * from "./HalfSib.vue?vue&type=script&lang=js&"
import style0 from "./HalfSib.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
